var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"product-name",attrs:{"translate":"no"}},[_c('a',{staticClass:"seo-link",attrs:{"href":_vm.href_articulo(_vm.article)},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(_vm._s(_vm.article_name))])])}
var staticRenderFns = []

export { render, staticRenderFns }